import { render, staticRenderFns } from "./SocialWidget.vue?vue&type=template&id=03e072ea&scoped=true&"
import script from "./SocialWidget.vue?vue&type=script&lang=js&"
export * from "./SocialWidget.vue?vue&type=script&lang=js&"
import style0 from "./SocialWidget.vue?vue&type=style&index=0&id=03e072ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e072ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
